import { Component, Prop, h, Watch, Element } from '@stencil/core';
import { handleAriaLabelChange } from '../../../shared/aria-utils';

@Component({
  tag: 'a1-status-icon',
  styleUrl: '../a1-icon.scss',
  scoped: true,
})
export class a1StatusIcon {
  @Element() host!: HTMLA1StatusIconElement;
  /**
   * Icon type and color.
   */
  @Prop({ reflect: true }) type: 'critical' | 'info' | 'positive' | 'warning' = 'info';

  /**
   * Icon size. For status icons: 's' or 'm' is valid
   *
   */
  @Prop({ reflect: true }) size: 's' | 'm' = 'm';

  /**
   * An alternate description to use for assistive devices. If omitted, the icon will be considered presentational and ignored by assistive devices.
   */
  @Prop() label: string = '';

  // Include special cases for status icons, and the default icon name.
  private get iconName(): string {
    switch (this.type) {
      case 'critical':
        return 'exclamation-circle';
      case 'info':
        return 'info-circle';
      case 'positive':
        return 'check-circle';
      case 'warning':
        return 'exclamation-triangle';
      default:
        return 'info-circle';
    }
  }

  private get classNames() {
    return {
      icon: true,
      [`c-icon--${this.iconName}`]: true,
      [this.type]: true,
      [this.size]: true,
    };
  }
  @Watch('label')
  getAriaLabelChange() {
    handleAriaLabelChange(this.host, this.label);
  }

  componentDidLoad() {
    this.getAriaLabelChange();
  }

  render() {
    return <i class={this.classNames}></i>;
  }
}
